/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { ManageProducts } from './ManageProducts'
import useUser from '../../Shared/UserProvider/useUser'
import { ProductAvailabilitiesImport } from '../ItemsList/ProductAvailabilitiesImport'

const ActionsBar = () => {
    const { user } = useUser()
    const companyCanCreateItems = user.provider.type === 'COMPANY' || user.canCreateItems

    return (
      <div
        css={css`
            display: flex;
            justify-content: flex-end;
        `}
      >
          {companyCanCreateItems ?
            <ManageProducts /> :
            <ProductAvailabilitiesImport />
          }
      </div>
    )
}

export { ActionsBar }
